// slider „Inni kupili również” – dane z /products/{id}/subelements/suggestion
//@ts-nocheck
import React, { FC } from 'react';
import classnames from 'classnames';
import {
  ButtonBack,
  ButtonNext,
  CarouselProvider,
  DotGroup,
  Slide,
  Slider
} from 'pure-react-carousel';
import { ChevronLeft, ChevronRight } from 'react-bootstrap-icons';

import { IProductListItem } from 'api/types';
import { useRWD } from 'hooks';
import { useGetProductSubelementItemsByType } from 'api/endpoints/useGetProductSubelementItemsByType';
import { Loader } from 'components/controls';
import ProductCard from 'components/containers/ProductCard/ProductCard';

import styles from 'theme/pages/Product/components/OthersAlsoBought/OthersAlsoBought.module.scss';

interface IProps {
  productId: number;
  items?: IProductListItem[];
}

const OthersAlsoBought: FC<IProps> = ({ productId, items: itemsProp }) => {
  const { isMobile, isDesktop } = useRWD();

  const { data: suggestionData, isLoading: isSuggestionLoading } =
    useGetProductSubelementItemsByType(
      productId,
      'suggestion',
      { page: 1, limit: 999 },
      { enabled: !!productId && itemsProp === undefined }
    );

  const productsData = itemsProp ?? suggestionData?.items ?? [];

  if (!productsData.length) {
    return null;
  }

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Page-Product-components-OthersAlsoBought'
      )}>
      {/* Nagłówek przeniesiony do Product.tsx nad Container */}
      {isSuggestionLoading && <Loader />}

      {productsData && productsData.length > 0 && (
        <div className={styles.sliderWrapper}>
          <CarouselProvider
            naturalSlideWidth={0}
            naturalSlideHeight={0}
            totalSlides={productsData.length}
            visibleSlides={isMobile ? 1.18 : isDesktop ? 4 : 5}
            disableKeyboard>
            <ButtonBack disabled={isMobile} className={classnames(styles.navButton, styles.back)}>
              <ChevronLeft />
            </ButtonBack>
            <ButtonNext disabled={isMobile} className={classnames(styles.navButton, styles.next)}>
              <ChevronRight />
            </ButtonNext>
            <Slider className={styles.slider}>
              {productsData.map((product, index) => (
                <Slide key={product.id} index={index} className={styles.slide}>
                  <div className={styles.productWrapper}>
                    <ProductCard product={product} />
                  </div>
                </Slide>
              ))}
            </Slider>
            {isMobile && <DotGroup className={styles.trayBar} />}
          </CarouselProvider>
        </div>
      )}
    </div>
  );
};

export default OthersAlsoBought;

